/* Shopify asset note: save this file as `performance-codex.js.liquid` so the served URL is `performance-codex.js`. */
(function () {
  var root = document.getElementById('oxygen-edge-dload');
  if (!root) return;
  if (root.dataset && root.dataset.gtInit === '1') return;
  if (root.dataset) root.dataset.gtInit = '1';

  var storageKey = 'trident_codex_unlocked_v1';
  var wantsPrintKey = 'trident_codex_wants_print_v1';
  var activeProgramKey = 'trident_codex_active_program_v1';
  var accordionTouchedKey = 'trident_codex_accordion_touched_v1';
  var stickyClosedKey = 'trident_codex_sticky_closed_v1';
  var baseTitle = document.title;
  var pdfTitle = 'Guardian Tape - Trident Performance Codex';
  var unlockedInSession = false;
  var scrollHighlightObserver = null;
  var scrollHighlightProgram = '';
  var trackedUnlockKey = 'trident_codex_tracked_unlock_v1';
  var printInProgress = false;
  var printGuardTimer = 0;

  function setPrintButtonsBusy(isBusy) {
    try {
      var btns = root.querySelectorAll('[data-oe-print]');
      btns.forEach(function (btn) {
        try { btn.disabled = !!isBusy; } catch (e) {}
        if (isBusy) btn.setAttribute('aria-busy', 'true');
        else btn.removeAttribute('aria-busy');
        btn.classList.toggle('is-busy', !!isBusy);
      });
    } catch (e) {}
  }

  function beginPrintFlow() {
    if (printInProgress) return false;
    printInProgress = true;
    setPrintButtonsBusy(true);
    try { if (printGuardTimer) clearTimeout(printGuardTimer); } catch (e) {}
    printGuardTimer = setTimeout(function () {
      printInProgress = false;
      setPrintButtonsBusy(false);
    }, 15000);
    return true;
  }

  function endPrintFlow() {
    if (!printInProgress) return;
    printInProgress = false;
    setPrintButtonsBusy(false);
    try { if (printGuardTimer) clearTimeout(printGuardTimer); } catch (e) {}
    printGuardTimer = 0;
  }

  function track(name, data) {
    try {
      if (typeof window.gtTrack === 'function') {
        window.gtTrack(name, data || {});
        return;
      }
    } catch (e) {}
    var payload = data || {};
    payload.name = name;
    payload.ts = Date.now();
    try { document.dispatchEvent(new CustomEvent('gtLeadMagnetEvent', { detail: payload })); } catch (e) {}
    try {
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'gtLeadMagnetEvent', gt_name: name }, payload));
      }
    } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch (e) {}
  }

  function safeGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function safeSet(key, value) { try { window.localStorage.setItem(key, value); } catch (e) {} }
  function safeRemove(key) { try { window.localStorage.removeItem(key); } catch (e) {} }
  function safeSessionGet(key) { try { return window.sessionStorage.getItem(key); } catch (e) { return null; } }
  function safeSessionSet(key, value) { try { window.sessionStorage.setItem(key, value); } catch (e) {} }
  function safeSessionRemove(key) { try { window.sessionStorage.removeItem(key); } catch (e) {} }

  function readPostedSuccess() {
    var el = root.querySelector('[data-oe-posted-success]');
    if (!el) return false;
    return el.getAttribute('data-oe-posted-success') === 'true';
  }

  function isUnlocked() { return unlockedInSession || safeGet(storageKey) === '1'; }

  var stickyEl = root.querySelector('[data-gt-sticky]');
  function updateStickyVisibility() {
    if (!stickyEl) return;
    var shouldHide = !isUnlocked() || safeSessionGet(stickyClosedKey) === '1';
    stickyEl.classList.toggle('is-hidden', shouldHide);
  }

  function setUnlocked() {
    safeSet(storageKey, '1');
    unlockedInSession = true;
    root.classList.remove('is-locked');
    root.classList.add('is-unlocked');
    updateStickyVisibility();
    if (safeSessionGet(trackedUnlockKey) !== '1') {
      safeSessionSet(trackedUnlockKey, '1');
      track('codex_unlock', { program: safeGet(activeProgramKey) || 'oxygen' });
    }
  }

  function setLocked() {
    unlockedInSession = false;
    root.classList.remove('is-unlocked');
    root.classList.add('is-locked');
    updateStickyVisibility();
  }

  /* Program tabs (in-page, not links) */
  function setActiveProgram(id) {
    if (!id) id = 'oxygen';
    safeSet(activeProgramKey, id);

    var tabs = root.querySelectorAll('[data-codex-tab]');
    tabs.forEach(function (btn) {
      var isActive = btn.getAttribute('data-codex-tab') === id;
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var panels = root.querySelectorAll('[data-codex-panel]');
    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-codex-panel') === id;
      panel.classList.toggle('is-active', isActive);
    });

    /* When switching programs, scroll to top of content area for clarity (unlocked only) */
    if (isUnlocked()) {
      try {
        var content = root.querySelector('[data-oe-content]');
        if (content) content.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {}
    }

    setAccordionDefaults();
    initScrollHighlights();
  }

  function getActivePanel() {
    return root.querySelector('.gt-codex-panel.is-active');
  }

  function setAccordionDefaults() {
    if (safeSessionGet(accordionTouchedKey) === '1') return;
    var panel = getActivePanel();
    if (!panel) return;

    var accordions = Array.prototype.slice.call(panel.querySelectorAll('details.gt-accordion'));
    if (!accordions.length) return;

    accordions.forEach(function (d, idx) {
      d.open = idx === 0;
    });
  }

  function setAllAccordions(open) {
    var panel = getActivePanel();
    if (!panel) return;
    var accordions = Array.prototype.slice.call(panel.querySelectorAll('details.gt-accordion'));
    if (!accordions.length) return;
    accordions.forEach(function (d) { d.open = !!open; });
    safeSessionSet(accordionTouchedKey, '1');
  }

  function openAccordionForAnchor(hash) {
    if (!hash || hash.charAt(0) !== '#') return;
    var target = null;
    try { target = root.querySelector(hash); } catch (e) { target = null; }
    if (!target) return;
    var details = null;
    try {
      if (target.closest) details = target.closest('details.gt-accordion');
    } catch (e) {}
    if (!details) {
      try { details = target.querySelector && target.querySelector('details.gt-accordion'); } catch (e) { details = null; }
    }
    if (details) details.open = true;
  }

  function initScrollHighlights() {
    if (!('IntersectionObserver' in window)) return;

    var panel = getActivePanel();
    if (!panel) return;

    var activeProgramId = panel.getAttribute('data-codex-panel') || '';
    if (scrollHighlightObserver) {
      try { scrollHighlightObserver.disconnect(); } catch (e) {}
      scrollHighlightObserver = null;
    }
    scrollHighlightProgram = activeProgramId;

    var linkMap = {};

    function addLink(id, el) {
      if (!id || !el) return;
      if (!linkMap[id]) linkMap[id] = [];
      linkMap[id].push(el);
    }

    /* TOC chips */
    Array.prototype.slice.call(panel.querySelectorAll('.gt-toc a[href^=\"#\"]')).forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var id = href.slice(1);
      addLink(id, a);
    });

    /* Phase rail links */
    Array.prototype.slice.call(panel.querySelectorAll('[data-gt-phase-link]')).forEach(function (a) {
      addLink(a.getAttribute('data-gt-phase-link'), a);
    });

    var ids = Object.keys(linkMap);
    if (!ids.length) return;

    var activeId = '';

    function setActive(id) {
      if (!id || id === activeId) return;
      activeId = id;
      ids.forEach(function (k) {
        linkMap[k].forEach(function (el) {
          el.setAttribute('aria-current', k === id ? 'true' : 'false');
        });
      });
    }

    var observed = [];
    ids.forEach(function (id) {
      var el = panel.querySelector('#' + id);
      if (el) observed.push(el);
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.target && e.target.id) setActive(e.target.id);
      });
    }, { rootMargin: '-25% 0px -65% 0px', threshold: 0.01 });

    scrollHighlightObserver = io;
    observed.forEach(function (el) { io.observe(el); });
  }

  root.addEventListener('click', function (e) {
    var tab = e.target && e.target.closest ? e.target.closest('[data-codex-tab]') : null;
    if (tab) {
      e.preventDefault();
      var id = tab.getAttribute('data-codex-tab');
      track('codex_program_change', { program: id || 'oxygen' });
      setActiveProgram(id);
      return;
    }

    var stickyClose = e.target && e.target.closest ? e.target.closest('[data-gt-sticky-close]') : null;
    if (stickyClose) {
      e.preventDefault();
      safeSessionSet(stickyClosedKey, '1');
      updateStickyVisibility();
      track('codex_sticky_close', { program: safeGet(activeProgramKey) || 'oxygen' });
      return;
    }

    var summary = e.target && e.target.closest ? e.target.closest('summary') : null;
    if (summary && summary.closest && summary.closest('details.gt-accordion')) {
      safeSessionSet(accordionTouchedKey, '1');
    }

    var reset = e.target && e.target.closest ? e.target.closest('[data-oe-reset]') : null;
    if (reset) {
      e.preventDefault();
      safeRemove(storageKey);
      safeSessionRemove(wantsPrintKey);
      setLocked();
      window.location.reload();
      return;
    }

    var btn = e.target && e.target.closest ? e.target.closest('[data-oe-print]') : null;
    if (btn) {
      e.preventDefault();
      track('codex_pdf_download_click', { program: safeGet(activeProgramKey) || 'oxygen' });
      openPrintWindow();
    }

    var expandAll = e.target && e.target.closest ? e.target.closest('[data-gt-expand-all]') : null;
    if (expandAll) {
      e.preventDefault();
      setAllAccordions(true);
      track('codex_expand_all', { program: safeGet(activeProgramKey) || 'oxygen' });
      return;
    }

    var collapseAll = e.target && e.target.closest ? e.target.closest('[data-gt-collapse-all]') : null;
    if (collapseAll) {
      e.preventDefault();
      setAllAccordions(false);
      track('codex_collapse_all', { program: safeGet(activeProgramKey) || 'oxygen' });
      return;
    }

    var mealPlan = e.target && e.target.closest ? e.target.closest('[data-gt-meal-plan]') : null;
    if (mealPlan) {
      e.preventDefault();
      var fromProgram = safeGet(activeProgramKey) || 'oxygen';
      track('codex_meal_plan_click', { from: fromProgram });
      setActiveProgram('meal');
      setTimeout(function () {
        var hash = '#meal-plan';
        try {
          var el = root.querySelector(hash);
          if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e2) {}
        openAccordionForAnchor(hash);
      }, 80);
      return;
    }

    var checkoutLink = e.target && e.target.closest ? e.target.closest('a[href*="return_to=/checkout"]') : null;
    if (checkoutLink) {
      var inSticky = false;
      try { inSticky = !!(checkoutLink.closest && checkoutLink.closest('[data-gt-sticky]')); } catch (e) {}
      track('codex_checkout_click', { program: safeGet(activeProgramKey) || 'oxygen', location: inSticky ? 'sticky' : 'content' });
    }

    var anchor = e.target && e.target.closest ? e.target.closest('a[href^=\"#\"]') : null;
    if (anchor) {
      openAccordionForAnchor(anchor.getAttribute('href') || '');
    }
  });

  /* Mobile table labels (card view) */
  function enhanceTables() {
    var tables = root.querySelectorAll('table.oe-table');
    tables.forEach(function (table) {
      var headers = Array.prototype.slice.call(table.querySelectorAll('thead th')).map(function (th) {
        return (th.textContent || '').trim();
      });
      if (!headers.length) return;
      Array.prototype.slice.call(table.querySelectorAll('tbody tr')).forEach(function (tr) {
        Array.prototype.slice.call(tr.children).forEach(function (td, idx) {
          if (td && td.tagName && td.tagName.toLowerCase() === 'td' && !td.getAttribute('data-label')) {
            td.setAttribute('data-label', headers[idx] || '');
          }
        });
      });
    });
  }
  enhanceTables();

  /* Scroll progress */
  var progressBar = root.querySelector('.gt-progress__bar');
  function updateProgress() {
    if (!progressBar) return;
    var doc = document.documentElement;
    var scrollTop = doc.scrollTop || document.body.scrollTop || 0;
    var scrollHeight = doc.scrollHeight - doc.clientHeight;
    var p = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
    progressBar.style.width = Math.max(0, Math.min(100, p)) + '%';
  }
  var raf = 0;
  window.addEventListener('scroll', function () {
    if (raf) return;
    raf = window.requestAnimationFrame(function () { raf = 0; updateProgress(); });
  }, { passive: true });
  updateProgress();

  /* Manual print safety (ensure accordions render full content) */
  window.addEventListener('beforeprint', function () {
    try {
      Array.prototype.slice.call(root.querySelectorAll('details.gt-accordion')).forEach(function (d) { d.open = true; });
    } catch (e) {}
  });

  /* Print/PDF flow */
  function openPrintWindow() {
    if (!isUnlocked()) return;
    if (!beginPrintFlow()) return;

    var content = root.querySelector('[data-oe-content]');
    var styleEl = root.querySelector('style');
    if (!content || !styleEl) {
      document.title = pdfTitle;
      try { window.print(); } finally { setTimeout(endPrintFlow, 600); }
      return;
    }

    var existingFrame = document.getElementById('oePrintFrame');
    if (existingFrame && existingFrame.parentNode) existingFrame.parentNode.removeChild(existingFrame);

    var frame = document.createElement('iframe');
    frame.id = 'oePrintFrame';
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.style.opacity = '0';
    frame.style.pointerEvents = 'none';
    document.body.appendChild(frame);

    var css = styleEl.textContent || '';

    var temp = document.createElement('div');
    temp.innerHTML = content.innerHTML;

    /* Remove scripts + interactive-only blocks in PDF */
    temp.querySelectorAll('script').forEach(function (el) { el.remove(); });
    temp.querySelectorAll('.oe-actions').forEach(function (el) { el.remove(); });

    /* PDF: print the active program panel */
    var activePanelId = 'oxygen';
    try {
      var activePanel = getActivePanel();
      activePanelId = (activePanel && activePanel.getAttribute('data-codex-panel')) || (safeGet(activeProgramKey) || 'oxygen');
    } catch (e) {}

    temp.querySelectorAll('[data-codex-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-codex-panel') === activePanelId;
      panel.classList.toggle('is-active', isActive);
    });

    /* PDF: expand all accordions */
    temp.querySelectorAll('details.gt-accordion').forEach(function (d) { d.setAttribute('open', ''); });

    var contentHtml = temp.innerHTML;

    var hasPrinted = false;
    function cleanup() {
      try { if (frame && frame.parentNode) frame.parentNode.removeChild(frame); } catch (e) {}
      endPrintFlow();
    }

    function triggerPrint() {
      if (hasPrinted) return;
      hasPrinted = true;
      try {
        if (frame.contentWindow) frame.contentWindow.focus();
        if (frame.contentWindow) frame.contentWindow.print();
      } finally {
        setTimeout(cleanup, 250);
      }
    }

    var buildStarted = false;
    function buildAndPrint() {
      if (buildStarted) return;
      buildStarted = true;
      var doc = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
      if (!doc || !doc.documentElement) {
        document.title = pdfTitle;
        try { window.print(); } finally { cleanup(); }
        return;
      }

      doc.open();
      doc.write('<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"></head><body></body></html>');
      doc.close();

      doc.title = pdfTitle;
      doc.documentElement.style.background = '#000000';
      doc.body.style.background = '#000000';

      var styleTag = doc.createElement('style');
      styleTag.textContent = css;
      doc.head.appendChild(styleTag);

      var section = doc.createElement('section');
      section.id = 'oxygen-edge-dload';
      section.className = 'is-unlocked is-pdf';
      section.innerHTML = '<div class="container">' + contentHtml + '</div>';
      doc.body.appendChild(section);

      try {
        Array.prototype.slice.call(section.querySelectorAll('details.gt-accordion')).forEach(function (d) { d.open = true; });
      } catch (e) {}

      (function schedulePrint() {
        var maxWaitMs = 1200;
        var done = false;

        function finish() {
          if (done) return;
          done = true;
          setTimeout(triggerPrint, 50);
        }

        var timer = setTimeout(finish, maxWaitMs);

        try {
          if (doc.fonts && doc.fonts.ready && typeof doc.fonts.ready.then === 'function') {
            doc.fonts.ready.then(function () {
              clearTimeout(timer);
              finish();
            }).catch(function () {
              clearTimeout(timer);
              finish();
            });
            return;
          }
        } catch (e) {}

        clearTimeout(timer);
        setTimeout(triggerPrint, 650);
      })();
    }

    frame.addEventListener('load', function () { setTimeout(buildAndPrint, 30); });
    setTimeout(buildAndPrint, 30);
  }

  /* Gate submit intent */
  var gateForm = root.querySelector('#OxygenEdgeGate');
  if (gateForm) {
    gateForm.addEventListener('submit', function () { safeSessionSet(wantsPrintKey, '1'); });
  }

  /* Initialize unlock state */
  if (root.classList.contains('is-unlocked')) setUnlocked();
  if (isUnlocked()) setUnlocked();
  if (readPostedSuccess()) setUnlocked();
  if (!isUnlocked()) setLocked();

  /* Initialize active program */
  var initialProgram = safeGet(activeProgramKey) || 'oxygen';
  if (initialProgram === 'meal') initialProgram = 'oxygen';
  setActiveProgram(initialProgram);

  /* Auto-print after successful capture */
  if (readPostedSuccess() && safeSessionGet(wantsPrintKey) === '1') {
    safeSessionRemove(wantsPrintKey);
    window.addEventListener('load', function () { setTimeout(openPrintWindow, 350); });
  }

  window.addEventListener('afterprint', function () { document.title = baseTitle; });
})();
